const Keys = {
    CIPHER_KEY: 'U2FsdGVkX1+JXubSHi8HbGbNClt0nl5aykdxOTaNVC4'
}

export default Keys